/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Accordion from 'shared/ui/components/Accordion.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import HorizontalDivider from 'shared/ui/components/HorizontalDivider.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';
import RegistrationType from 'shared/ui/components/registrations/RegistrationType.vue';
import StringsArrayInput from 'shared/ui/components/form-components/StringsArrayInput.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';
import TargetingControl from 'shared/ui/components/form-components/TargetingControl.vue';
import ButtonsToggle from 'shared/ui/components/ButtonsToggle.vue';
import MappedFields from 'shared/ui/components/MappedFields.vue';

// Mixins
import form from 'shared/ui/components/registrations/form';

const AUTH_TYPE = {
    EMAIL: 'email',
    EMAIL_SSO: 'email_sso',
    SSO: 'sso'
};
const badgeOption = {
    access_code: {
        badge: 'reg_types.hybrid.title'
    },
    access_limitation: {
        badge: 'reg_types.hybrid.title'
    },
    integration: {
        badge: 'reg_types.hybrid.title'
    },
    session_registration: {
        badge: 'reg_types.hybrid.title'
    },
    authentication: {
        badge: 'reg_types.public.short_title'
    },
    manual_approval: {
        badge: 'reg_types.public.short_title'
    },
    email_domains: {
        badge: 'reg_types.public.short_title'
    },
    notification_emails: {
        badge: 'reg_types.hybrid.title'
    },
    embed: {
        badge: 'reg_types.hybrid.title'
    },
};

const __vue_script__ = {
    name: 'Settings',

    components: {
        Accordion,
        BaseInput,
        BaseSelect,
        Checkbox,
        RadioButtons,
        StringsArrayInput,
        Toggler,
        RegistrationType,
        HorizontalDivider,
        TargetingControl,
        ButtonsToggle,
        MappedFields
    },

    mixins: [form],

    props: {
        settings: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            required: true
        },


        eventDetails: {
            type: Object,
            required: true
        },

        hasSessionsInForms: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        const emailDomainsPolicyOptions = [{
            value: 'any',
            label: this.t('form.email_domains.any')
        }, {
            value: 'pass_list',
            label: this.t('form.pass_list')
        }, {
            value: 'block_list',
            label: this.t('form.block_list')
        }];

        const authenticationChoice = (type) => {
            return {
                label: this.t(`authentication_type.${type}`),
                hint: this.t(`authentication_type.${type}_hint`),
                value: type,
                newLineHint: true
            };
        };

        return {
            authenticationChoices: [
                authenticationChoice(AUTH_TYPE.EMAIL),
                authenticationChoice(AUTH_TYPE.SSO),
                authenticationChoice(AUTH_TYPE.EMAIL_SSO),
            ],
            authenticationType: null,
            availableSSOs: [],
            badgeOption,
            disableLogin: false,
            skipPinCode: false,
            enableSelfRegCapacity: false,
            enableSelfRegWaitingList: false,
            selfRegCapacity: undefined,
            enableRSVPUserCapacity: false,
            rsvpUserCapacity: undefined,
            enableMinSessionRegistrations: false,
            enableEmbed: false,
            minSessionRegistrations: undefined,
            disableReg: false,
            emailPolicy: null,
            emailDomainsPolicyOptions,
            enablePrivateReg: false,
            registrationType: this.value.access_type || 'public',
            selectedSSOs: [],
            showAuthenticationsOptions: this.options.authenticationTypeEnabled === true,
            showNotificationsOptions: this.options.organizerNotificationsEnabled === true,
            showUseLimitsOptions: this.options.userLimitsEnabled === true,
            isSessionRegEnabled: this.options.sessionRegistrationEnabled === true,
            showPaymentSettings: this.eventDetails.show_payment_section,
            paymentEnabled: false,
            paymentEventId: '',
            integrationName: '',
            integrationUrl: '',
            integrationSecretKey: '',
            showIntegrationSecret: false,
            integrationApiFields: {},
            integrationTriggerFields: [],
            integrationPopulateFields: [],
            integrationMatchFields: [],
            integrationSearchFields: [],
            registrationFieldsByKey: {},
            metadataFieldOptions: [],
            integrationTargeting: {},
            isSpotmeUser: this.$services.user.matchesRoles({ isSpotme: true }),
            embedCodeVersion: 'basic',
            embedCodeButtonList: [{
                key: 'registration.configuration.embed_code',
                value: 'basic'
            }, {
                key: 'registration.configuration.embed_code_with_utm',
                value: 'with_utm'
            }],
            skipReload: false,
            gtmContainerId: '',
            linkedinPartnerId: ''
        };
    },

    computed: {
        integrationSearchFieldOptions() {
            const map = this.innerValue?.integration_fields_map || {};
            const metadataFields = new Set(Object.entries(map)
                .filter(([apiField, mdField]) => mdField && (this.integrationApiFields.searchable || []).includes(apiField))
                .map(([, mdField]) => mdField)
            );
            return Object.entries(this.registrationFieldsByKey)
                .filter(([key]) => metadataFields.has(key))
                .map(([key, label]) => ({ value: key, label }));
        },

        selfRegisteredUserLimitsDetails() {
            const current = this.eventDetails?.self_registered_user_count;
            const max = this.settings?.self_registered_user_limit;
            if (current && max) {
                return this.$t('registration.configuration.actions.registration_status') + ' ' + current + '/' + max;
            }
            return '';
        },

        rsvpUserLimitsDetails() {
            const current = this.eventDetails?.rsvp_accepted_user_count;
            const max = this.settings?.rsvp_accepted_user_limit;
            if (current && max) {
                return this.$t('registration.configuration.actions.registration_status') + ' ' + current + '/' + max;
            }
            return '';
        },

        disableManualApproval() {
            return this.enableSelfRegWaitingList || this.hasSessionsInForms;
        },

        waitlistTip() {
            if (this.disableManualApproval && this.hasSessionsInForms) {
                return this.t('remove_sessions_reg_to_enable');
            } else if (this.innerValue?.manual_approval) {
                return this.t('disable_manual_approval');
            }

            return null;
        },

        integrationMappedFields() {
            const map = this.innerValue?.integration_fields_map || {};
            const metadataFields = Object.values(map);
            return metadataFields.map(field => ({
                value: field,
                label: this.registrationFieldsByKey[field] || field
            }));
        }
    },

    watch: {
        value: {
            immediate: true,
            deep: true,
            handler() {
                this.disableLogin = Boolean(this.innerValue.disable_login);
                this.disableReg = Boolean(this.innerValue.disable_registration);

                this.enablePrivateReg = Boolean(this.innerValue.enable_private_registration);

                this.selfRegCapacity = Number(this.innerValue.self_registered_user_limit) || '';
                this.enableSelfRegWaitingList = Boolean(this.innerValue.self_registered_waiting_list) && !this.hasSessionsInForms;

                this.rsvpUserCapacity = Number(this.innerValue.rsvp_accepted_user_limit) || '';

                this.minSessionRegistrations = Number(this.innerValue.min_registered_sessions) || '';

                if (this.innerValue.enable_sso_login) {
                    if (this.innerValue.disable_email_login) {
                        this.authenticationType = AUTH_TYPE.SSO;
                    } else {
                        this.authenticationType = AUTH_TYPE.EMAIL_SSO;
                    }
                } else {
                    this.authenticationType = AUTH_TYPE.EMAIL;
                }
            }
        },

        authenticationType(authType) {
            switch (authType) {
                case AUTH_TYPE.EMAIL:
                    this.setValue('enable_sso_login', false);
                    this.setValue('disable_email_login', false);
                    this.setValue('enabled_ssos', []);
                    this.selectedSSOs = [];
                    break;
                case AUTH_TYPE.EMAIL_SSO:
                    this.setValue('enable_sso_login', true);
                    this.setValue('disable_email_login', false);
                    break;
                case AUTH_TYPE.SSO:
                    this.setValue('enable_sso_login', true);
                    this.setValue('disable_email_login', true);
                    break;
            }
        },

        emailPolicy(policy) {
            this.setValue('email_domains_policy', policy.value);
        },

        disableLogin(value) {
            this.setValue('disable_login', value);
        },

        disableReg(value) {
            this.setValue('disable_registration', value);
        },

        enableSelfRegCapacity(value) {
            if (value === false) {
                this.setValue('self_registered_user_limit', 0);
                this.setValue('self_registered_waiting_list', false);
            }
        },

        selfRegCapacity(value) {
            if (value === '') {
                return;
            }
            this.setValue('self_registered_user_limit', value);
        },

        enableSelfRegWaitingList(value) {
            this.setValue('self_registered_waiting_list', value);
        },

        enableRSVPUserCapacity(value) {
            if (value === false) {
                this.setValue('rsvp_accepted_user_limit', 0);
            }
        },

        rsvpUserCapacity(value) {
            if (value === '') {
                return;
            }
            this.setValue('rsvp_accepted_user_limit', value);
        },

        skipPinCode(value) {
            this.setValue('skip_pin_for_team_members', value);
        },

        enableMinSessionRegistrations(value) {
            if (value === false) {
                this.setValue('min_registered_sessions', 0);
            }
        },

        enableEmbed(value) {
            this.setValue('enable_embed', value);
        },

        minSessionRegistrations(value) {
            if (value === '') {
                return;
            }
            this.setValue('min_registered_sessions', value);
        },

        registrationType(value) {
            if (!this.innerValue.hasOwnProperty('enable_private_registration') && value !== 'public') {
                this.setValue('enable_private_registration', true);
            }

            this.setValue('allow_profile_updates', value !== 'public');
            this.setValue('access_type', value);

            this.saveChanges(true, false);

        },

        selectedSSOs(ssos) {
            this.setValue('enabled_ssos', ssos.map(sso => sso.value));
        },

        integrationName(value) {
            this.setValue('integration_name', value);
        },

        integrationUrl(value) {
            this.setValue('integration_url', value);
        },

        integrationSecretKey(value) {
            this.setValue('integration_secret_key', value);
        },

        integrationTargeting(value) {
            this.setValue('integration_targeting', value);
        },

        integrationTriggerFields(value) {
            this.setValue('integration_trigger_fields', value);
        },

        integrationPopulateFields(value) {
            this.setValue('integration_populate_fields', value);
        },

        integrationMatchFields(value) {
            this.setValue('integration_match_fields', value);
        },

        integrationSearchFields(value) {
            this.setValue('integration_search_fields', value);
        },

        gtmContainerId(value) {
            this.setValue('gtm_container_id', value);
        },

        linkedinPartnerId(value) {
            this.setValue('linkedin_partner_id', value);
        },
    },

    async created() {
        this.disableLogin = Boolean(this.innerValue.disable_login);
        this.disableReg = Boolean(this.innerValue.disable_registration);

        this.enableSelfRegCapacity = Boolean(this.innerValue.self_registered_user_limit && this.innerValue.self_registered_user_limit > 0);
        this.selfRegCapacity = this.innerValue.self_registered_user_limit || '';
        this.enableSelfRegWaitingList = Boolean(this.innerValue.self_registered_waiting_list);

        this.enableRSVPUserCapacity = Boolean(this.innerValue.rsvp_accepted_user_limit && this.innerValue.rsvp_accepted_user_limit > 0);
        this.rsvpUserCapacity = this.innerValue.rsvp_accepted_user_limit || '';

        this.skipPinCode = Boolean(this.innerValue.skip_pin_for_team_members);
        this.enableMinSessionRegistrations = Boolean(this.innerValue.min_registered_sessions > 0);
        this.enableEmbed = Boolean(this.innerValue.enable_embed);
        this.minSessionRegistrations = this.innerValue.min_registered_sessions || '';

        this.emailPolicy = this.emailDomainsPolicyOptions.find(p => p.value === this.innerValue.email_domains_policy) || this.emailDomainsPolicyOptions[0];

        if (this.event.branded_app) {
            const branding = await this.$services.branding.getBranding(this.event.branded_app);
            const availableSSOs = [];
            const selectedSSOs = [];
            Object.entries(branding.sso_config).forEach(([key, value]) => {
                const selectEntry = {
                    label: value?.conf?.label || key,
                    value: key
                };
                availableSSOs.push(selectEntry);
                if (this.innerValue.enabled_ssos?.includes(key)) {
                    selectedSSOs.push(selectEntry);
                }
            });
            this.availableSSOs = availableSSOs;
            this.selectedSSOs = selectedSSOs;
        }

        if (this.hasSessionsInForms && this.settings.manual_approval) {
            this.setValue('manual_approval', false);
        }

        this.paymentEnabled = Boolean(this.innerValue.payment_enabled);
        this.paymentEventId = this.innerValue.payment_event_id || '';
        this.integrationName = this.innerValue.integration_name || '';
        this.integrationUrl = this.innerValue.integration_url || '';
        this.integrationSecretKey = this.innerValue.integration_secret_key || '';
        this.integrationTargeting = this.innerValue.integration_targeting;
        this.integrationTriggerFields = this.innerValue.integration_trigger_fields || [];
        this.integrationPopulateFields = this.innerValue.integration_populate_fields || [];
        this.integrationMatchFields = this.innerValue.integration_match_fields || [];
        this.integrationSearchFields = this.innerValue.integration_search_fields || [];

        this.gtmContainerId = this.innerValue.gtm_container_id || '';
        this.linkedinPartnerId = this.innerValue.linkedin_partner_id || '';

        await this.loadIntegrationFields();
    },

    methods: {
        /**
         * @param {string} domain
         */
        normalizeDomain(domain) {
            return (domain || '')
                .replace(/\s+/g, '')
                .toLocaleLowerCase();
        },

        /**
         * @param {boolean} value
         */
        toggleRegistration(value) {
            this.$modal.hide('disable-registration');
            this.setValue('enabled', value);
        },

        /**
         * Little i18n shortcut to avoid duplications.
         * @param {String} key
         */
        t(key) {
            return this.$t(`registration.configuration.${key}`);
        },

        getEmbedUrl() {
            const regUrl = this.event.is_template
                ? this.$utils.url.getWebappRegistrationUrlForTemplate(this.event._id)
                : this.$utils.url.getWebappRegistrationUrl(
                    this.event.branded_app,
                    this.eventDetails.path_name,
                    {
                        noCache: false,
                        whiteLabelDomain: this.event.white_label_domain,
                    }
                );
            const { origin, pathname } = new URL(regUrl);
            // The `_c` parameter is just added to force any caching. The user
            // will see at the very least the version of the page when the embedding was last done.
            // Note that this does not disable caching after that.
            return this.$utils.url.appendCacheBuster(`${origin}/embed${pathname}`);
        },

        getEmbedCode() {
            return [
                '<iframe',
                `  src="${this.getEmbedUrl()}">`,
                '</iframe>',
            ].join('\n');
        },

        getEmbedCodeWithUtm() {
            return [
                '<script>',
                '  function iframeSrcHandling() {',
                `    const baseIframeUrl = new URL('${this.getEmbedUrl()}');`,
                '    const windowUrlParams = new URLSearchParams(window.location.search);',
                '    const iframeUrlParams = baseIframeUrl.searchParams;',
                '    const utmParams = [\'gclid\', \'utm_source\', \'utm_medium\', \'utm_campaign\', \'utm_term\', \'utm_content\'];',
                '    for (let utm of utmParams) {',
                '      const utmValue = windowUrlParams.get(utm);',
                '      if (utmValue) {',
                '        iframeUrlParams.append(utm, utmValue);',
                '      }',
                '    }',
                '    document.getElementById(\'spotme-reg-iframe\').src = baseIframeUrl.toString();',
                '  }',
                '  window.onload = () => {',
                '    iframeSrcHandling();',
                '  };',
                '<\/script>',
                '<iframe id="spotme-reg-iframe" src=""></iframe>',
            ].join('\n');
        },

        async copyEmbedCodeToClipboard(code) {
            try {
                await navigator.clipboard.writeText(code);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('general.copy_success').toString(),
                    type: 'success'
                });
            } catch (e) {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('general.copy_failed').toString(),
                    type: 'error'
                });
            }
        },

        async loadIntegrationFields() {
            if (!this.isSpotmeUser) {
                return;
            }

            try {
                const eid = this.event._id;
                const metadata = await this.$services.metadata.getUserRegistrationFields(eid);
                this.metadataFieldOptions = metadata
                    .map(m => ({ value: m.name, label: m.label }));
                this.registrationFieldsByKey = metadata.reduce((acc, field) => {
                    acc[field.name] = field.label;
                    return acc;
                }, {});
            } catch (error) {
                console.error('[Settings] Could not load user metadata for integration fields', error);
            }

            try {
                const configs = await this.$services.integrations.getIntegrationConfigs(this.event._id);
                this.integrationApiFields = configs.find(cfg => cfg.is_reg_config) || {};
            } catch (err) {
                console.error('[Settings] Could not load integration API fields', err);
            }
        },

        async onMappedFieldsSaved() {
            const mapped = Object.values(this.innerValue.integration_fields_map);
            this.integrationSearchFields.filter(f => mapped.includes(f));
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    {
      ref: "form",
      staticClass: "settings",
      attrs: { tag: "form", autocomplete: "off" },
    },
    [
      _vm.options.registrationTypeEnabled
        ? _c("registration-type", {
            attrs: { name: "registrationType", "show-warning": true },
            model: {
              value: _vm.registrationType,
              callback: function ($$v) {
                _vm.registrationType = $$v
              },
              expression: "registrationType",
            },
          })
        : _vm._e(),
      _vm.settings.registration_type_enabled
        ? _c("horizontal-divider", { staticClass: "large with-parent" })
        : _vm._e(),
      _c("accordion", {
        attrs: {
          "headers-i18n-prefix": "registration.configuration",
          "default-open-item": "access_limitation",
          animated: true,
          "unlimited-height": true,
          slim: true,
          options: _vm.registrationType == "hybrid" ? _vm.badgeOption : {},
        },
        scopedSlots: _vm._u(
          [
            {
              key: "access_limitation",
              fn: function (ref) {
                return [
                  _vm.registrationType === "hybrid"
                    ? _c("h6", [
                        _vm._v(_vm._s(_vm.t("reg_types.public.title"))),
                      ])
                    : _vm._e(),
                  _vm.registrationType !== "private"
                    ? _c("toggler", {
                        attrs: {
                          name: "disable_registration",
                          "on-label":
                            "registration.configuration.actions.allow_registrations",
                          "off-label":
                            "registration.configuration.actions.allow_registrations",
                          inverted: true,
                          hint: _vm.t("actions.allow_registrations_hint"),
                        },
                        model: {
                          value: _vm.disableReg,
                          callback: function ($$v) {
                            _vm.disableReg = $$v
                          },
                          expression: "disableReg",
                        },
                      })
                    : _vm._e(),
                  _vm.registrationType !== "private" && _vm.showUseLimitsOptions
                    ? _c("toggler", {
                        attrs: {
                          name: "enable_self_reg_capacity",
                          "on-label":
                            "registration.configuration.actions.allow_self_user_limits",
                          "off-label":
                            "registration.configuration.actions.allow_self_user_limits",
                          hint: _vm.t("actions.allow_self_user_limits_hint"),
                        },
                        model: {
                          value: _vm.enableSelfRegCapacity,
                          callback: function ($$v) {
                            _vm.enableSelfRegCapacity = $$v
                          },
                          expression: "enableSelfRegCapacity",
                        },
                      })
                    : _vm._e(),
                  _vm.registrationType !== "private" &&
                  _vm.enableSelfRegCapacity &&
                  _vm.showUseLimitsOptions
                    ? _c(
                        "div",
                        { staticClass: "feature-dependant" },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "self_registered_user_limit",
                              rules:
                                "required|min_value:" +
                                (_vm.eventDetails.self_registered_user_count ||
                                  1) +
                                "|max_value:" +
                                (_vm.eventDetails.all_user_limit || 1000000),
                              slim: true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("base-input", {
                                        staticClass: "small-input",
                                        attrs: {
                                          type: "number",
                                          name: "self_registered_user_limit",
                                          errors: errors,
                                          hint: _vm.selfRegisteredUserLimitsDetails,
                                        },
                                        model: {
                                          value: _vm.selfRegCapacity,
                                          callback: function ($$v) {
                                            _vm.selfRegCapacity = $$v
                                          },
                                          expression: "selfRegCapacity",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c(
                            "toggler",
                            {
                              attrs: {
                                name: "self_registered_waiting_list",
                                disabled:
                                  _vm.innerValue.manual_approval ||
                                  _vm.hasSessionsInForms,
                                tip: _vm.waitlistTip,
                                "on-label":
                                  "registration.configuration.actions.enable_self_reg_waiting_list",
                                "off-label":
                                  "registration.configuration.actions.enable_self_reg_waiting_list",
                              },
                              model: {
                                value: _vm.enableSelfRegWaitingList,
                                callback: function ($$v) {
                                  _vm.enableSelfRegWaitingList = $$v
                                },
                                expression: "enableSelfRegWaitingList",
                              },
                            },
                            [
                              _vm.enableSelfRegWaitingList
                                ? _c(
                                    "i18n",
                                    {
                                      staticClass: "control-hint",
                                      attrs: {
                                        path: "registration.configuration.hint_manage_waiting_list",
                                        tag: "p",
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "/event/" +
                                              _vm.event._id +
                                              "/pax-requests",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.t("manage_pending_link_label")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.registrationType === "hybrid"
                    ? _c("h6", [
                        _vm._v(_vm._s(_vm.t("reg_types.private.title"))),
                      ])
                    : _vm._e(),
                  _vm.registrationType !== "public"
                    ? _c("toggler", {
                        attrs: {
                          value: _vm.enablePrivateReg,
                          name: "enable_private_reg",
                          "on-label":
                            "registration.configuration.actions.allow_private_registrations",
                          "off-label":
                            "registration.configuration.actions.allow_private_registrations",
                          hint: _vm.t(
                            "actions.allow_private_registrations_hint"
                          ),
                        },
                        on: {
                          input: function (value) {
                            return _vm.setValue(
                              "enable_private_registration",
                              value
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.registrationType !== "public" && _vm.showUseLimitsOptions
                    ? _c("toggler", {
                        attrs: {
                          name: "enable_rsvp_user_capacity",
                          "on-label":
                            "registration.configuration.actions.allow_rsvp_user_limits",
                          "off-label":
                            "registration.configuration.actions.allow_rsvp_user_limits",
                          hint: _vm.t("actions.allow_rsvp_user_limits_hint"),
                        },
                        model: {
                          value: _vm.enableRSVPUserCapacity,
                          callback: function ($$v) {
                            _vm.enableRSVPUserCapacity = $$v
                          },
                          expression: "enableRSVPUserCapacity",
                        },
                      })
                    : _vm._e(),
                  _vm.registrationType !== "public" &&
                  _vm.enableRSVPUserCapacity &&
                  _vm.showUseLimitsOptions
                    ? _c(
                        "div",
                        { staticClass: "feature-dependant" },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "rsvp_user_limit",
                              rules:
                                "required|min_value:" +
                                (_vm.eventDetails.rsvp_accepted_user_count ||
                                  1),
                              slim: true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("base-input", {
                                        staticClass: "small-input",
                                        attrs: {
                                          type: "number",
                                          name: "rsvp_user_limit",
                                          errors: errors,
                                          hint: _vm.rsvpUserLimitsDetails,
                                        },
                                        model: {
                                          value: _vm.rsvpUserCapacity,
                                          callback: function ($$v) {
                                            _vm.rsvpUserCapacity = $$v
                                          },
                                          expression: "rsvpUserCapacity",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.registrationType === "hybrid"
                    ? _c("h6", [
                        _vm._v(_vm._s(_vm.t("reg_types.hybrid.title"))),
                      ])
                    : _vm._e(),
                  _c("toggler", {
                    attrs: {
                      value: _vm.innerValue.allow_profile_updates,
                      name: "allow_profile_updates",
                      "on-label":
                        "registration.configuration.actions.allow_profile_updates",
                      "off-label":
                        "registration.configuration.actions.allow_profile_updates",
                      hint: _vm.t("actions.allow_profile_updates_hint"),
                    },
                    on: {
                      input: function (value) {
                        return _vm.setValue("allow_profile_updates", value)
                      },
                    },
                  }),
                  _c("toggler", {
                    attrs: {
                      name: "disable_login",
                      "on-label":
                        "registration.configuration.actions.allow_logins",
                      "off-label":
                        "registration.configuration.actions.allow_logins",
                      inverted: true,
                      hint: _vm.t("actions.allow_logins_hint"),
                    },
                    model: {
                      value: _vm.disableLogin,
                      callback: function ($$v) {
                        _vm.disableLogin = $$v
                      },
                      expression: "disableLogin",
                    },
                  }),
                ]
              },
            },
            {
              key: "integration",
              fn: function (ref) {
                return [
                  _c("p", [_vm._v(_vm._s(_vm.t("integration_description")))]),
                  _c("toggler", {
                    attrs: {
                      value: _vm.innerValue.profile_enrichment,
                      name: "profile_enrichment",
                      "on-label":
                        "registration.configuration.integration_label",
                      "off-label":
                        "registration.configuration.integration_label",
                    },
                    on: {
                      input: function (value) {
                        return _vm.setValue("profile_enrichment", value)
                      },
                    },
                  }),
                  _vm.innerValue.profile_enrichment
                    ? _c(
                        "div",
                        { staticClass: "integration-settings" },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "integration_name",
                              rules: "required",
                              slim: true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("base-input", {
                                        attrs: {
                                          label:
                                            _vm.t("integration_name") + " *",
                                          name: "integration_name",
                                          disabled: !_vm.isSpotmeUser,
                                          errors: errors,
                                        },
                                        model: {
                                          value: _vm.integrationName,
                                          callback: function ($$v) {
                                            _vm.integrationName = $$v
                                          },
                                          expression: "integrationName",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("validation-provider", {
                            attrs: {
                              name: "integration_url",
                              rules: "required",
                              slim: true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _vm.isSpotmeUser
                                        ? _c("base-input", {
                                            attrs: {
                                              label:
                                                _vm.t("integration_url") + " *",
                                              name: "integration_url",
                                              errors: errors,
                                            },
                                            model: {
                                              value: _vm.integrationUrl,
                                              callback: function ($$v) {
                                                _vm.integrationUrl = $$v
                                              },
                                              expression: "integrationUrl",
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _vm.isSpotmeUser
                            ? _c("validation-provider", {
                                attrs: {
                                  name: "integration_secret_key",
                                  rules: "required",
                                  slim: true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c(
                                            "base-input",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.t(
                                                    "integration_secret_key"
                                                  ) + " *",
                                                type: _vm.showIntegrationSecret
                                                  ? "text"
                                                  : "password",
                                                name: "integration_secret_key",
                                                errors: errors,
                                              },
                                              model: {
                                                value: _vm.integrationSecretKey,
                                                callback: function ($$v) {
                                                  _vm.integrationSecretKey = $$v
                                                },
                                                expression:
                                                  "integrationSecretKey",
                                              },
                                            },
                                            [
                                              _vm._t("default", function () {
                                                return [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-link ml-2",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.showIntegrationSecret =
                                                            !_vm.showIntegrationSecret
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.showIntegrationSecret
                                                            ? "Hide"
                                                            : "Show"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              }),
                                            ],
                                            2
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                          _vm.integrationApiFields.fields
                            ? _c("mapped-fields", {
                                attrs: {
                                  label: _vm.$t("integrations.fields_mapping"),
                                  "api-fields": _vm.integrationApiFields.fields,
                                  eid: _vm.event._id,
                                },
                                on: { saved: _vm.onMappedFieldsSaved },
                                model: {
                                  value: _vm.innerValue.integration_fields_map,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.innerValue,
                                      "integration_fields_map",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "innerValue.integration_fields_map",
                                },
                              })
                            : _vm._e(),
                          _c("validation-provider", {
                            attrs: {
                              name: "integration_search_fields",
                              rules: "required",
                              slim: true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("base-select", {
                                        attrs: {
                                          name: "integration_search_fields",
                                          label:
                                            _vm.$t(
                                              "integrations.search_fields"
                                            ) + " *",
                                          tip: _vm.t(
                                            "integration_search_fields_hint"
                                          ),
                                          options:
                                            _vm.integrationSearchFieldOptions,
                                          emitOptionValueOnly: true,
                                          "track-by": "value",
                                          multiple: true,
                                          disabled: !_vm.isSpotmeUser,
                                          errors: errors,
                                        },
                                        model: {
                                          value: _vm.integrationSearchFields,
                                          callback: function ($$v) {
                                            _vm.integrationSearchFields = $$v
                                          },
                                          expression: "integrationSearchFields",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("targeting-control", {
                            attrs: {
                              label: _vm.t("integration_targeting_label"),
                              name: "integration_targeting",
                              "hidden-to-label": _vm.t(
                                "integration_hidden_to_label"
                              ),
                              "hidden-to-desc": _vm.t(
                                "integration_hidden_to_desc"
                              ),
                              "show-targets": false,
                              "show-exceptions": true,
                              "show-affected-pax-btn": false,
                              expandable: true,
                              hint: " ",
                              "event-id": _vm.event._id,
                            },
                            model: {
                              value: _vm.integrationTargeting,
                              callback: function ($$v) {
                                _vm.integrationTargeting = $$v
                              },
                              expression: "integrationTargeting",
                            },
                          }),
                          _c("validation-provider", {
                            attrs: {
                              name: "integration_trigger_fields",
                              rules: "required",
                              slim: true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("base-select", {
                                        attrs: {
                                          name: "integration_trigger_fields",
                                          label:
                                            _vm.t(
                                              "integration_trigger_fields"
                                            ) + " *",
                                          placeholder: _vm.t(
                                            "integration_select_fields_placeholder"
                                          ),
                                          hint: _vm.t(
                                            "integration_trigger_fields_hint"
                                          ),
                                          "hint-after-label": true,
                                          options: _vm.metadataFieldOptions,
                                          emitOptionValueOnly: true,
                                          "track-by": "value",
                                          multiple: true,
                                          disabled: !_vm.isSpotmeUser,
                                          errors: errors,
                                        },
                                        model: {
                                          value: _vm.integrationTriggerFields,
                                          callback: function ($$v) {
                                            _vm.integrationTriggerFields = $$v
                                          },
                                          expression:
                                            "integrationTriggerFields",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("validation-provider", {
                            attrs: {
                              name: "integration_populate_fields",
                              rules: "required",
                              slim: true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("base-select", {
                                        attrs: {
                                          name: "integration_populate_fields",
                                          label:
                                            _vm.t(
                                              "integration_populate_fields"
                                            ) + " *",
                                          placeholder: _vm.t(
                                            "integration_select_fields_placeholder"
                                          ),
                                          hint: _vm.t(
                                            "integration_populate_fields_hint"
                                          ),
                                          "hint-after-label": true,
                                          options: _vm.integrationMappedFields,
                                          emitOptionValueOnly: true,
                                          "track-by": "value",
                                          multiple: true,
                                          disabled: !_vm.isSpotmeUser,
                                          errors: errors,
                                        },
                                        model: {
                                          value: _vm.integrationPopulateFields,
                                          callback: function ($$v) {
                                            _vm.integrationPopulateFields = $$v
                                          },
                                          expression:
                                            "integrationPopulateFields",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("validation-provider", {
                            attrs: {
                              name: "integration_match_fields",
                              rules: "required",
                              slim: true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("base-select", {
                                        attrs: {
                                          name: "integration_match_fields",
                                          label:
                                            _vm.t("integration_match_fields") +
                                            " *",
                                          placeholder: _vm.t(
                                            "integration_select_field_placeholder"
                                          ),
                                          hint: _vm.t(
                                            "integration_match_fields_hint"
                                          ),
                                          "hint-after-label": true,
                                          options: _vm.integrationMappedFields,
                                          emitOptionValueOnly: true,
                                          "track-by": "value",
                                          multiple: true,
                                          disabled: !_vm.isSpotmeUser,
                                          errors: errors,
                                        },
                                        model: {
                                          value: _vm.integrationMatchFields,
                                          callback: function ($$v) {
                                            _vm.integrationMatchFields = $$v
                                          },
                                          expression: "integrationMatchFields",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
            },
            _vm.isSessionRegEnabled
              ? {
                  key: "session_registration",
                  fn: function (ref) {
                    return [
                      _c("toggler", {
                        attrs: {
                          disabled: _vm.innerValue.manual_approval,
                          tip: _vm.innerValue.manual_approval
                            ? _vm.t("disable_manual_approval")
                            : null,
                          name: "enable_min_registered_sessions",
                          "on-label":
                            "registration.configuration.actions.enable_min_registered_sessions",
                          "off-label":
                            "registration.configuration.actions.enable_min_registered_sessions",
                          hint: _vm.t(
                            "actions.enable_min_registered_sessions_hint"
                          ),
                        },
                        model: {
                          value: _vm.enableMinSessionRegistrations,
                          callback: function ($$v) {
                            _vm.enableMinSessionRegistrations = $$v
                          },
                          expression: "enableMinSessionRegistrations",
                        },
                      }),
                      _vm.enableMinSessionRegistrations
                        ? _c(
                            "div",
                            { staticClass: "feature-dependant" },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "min_registered_sessions",
                                  rules:
                                    "required|min_value:" +
                                    (_vm.eventDetails.min_registered_sessions ||
                                      0),
                                  slim: true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("base-input", {
                                            staticClass: "small-input",
                                            attrs: {
                                              type: "number",
                                              name: "min_registered_sessions",
                                              errors: errors,
                                            },
                                            model: {
                                              value:
                                                _vm.minSessionRegistrations,
                                              callback: function ($$v) {
                                                _vm.minSessionRegistrations =
                                                  $$v
                                              },
                                              expression:
                                                "minSessionRegistrations",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                }
              : null,
            _vm.registrationType !== "private" && _vm.showAuthenticationsOptions
              ? {
                  key: "authentication",
                  fn: function (ref) {
                    return [
                      _c("radio-buttons", {
                        attrs: {
                          name: "authentication_type",
                          options: _vm.authenticationChoices,
                        },
                        model: {
                          value: _vm.authenticationType,
                          callback: function ($$v) {
                            _vm.authenticationType = $$v
                          },
                          expression: "authenticationType",
                        },
                      }),
                      _vm.innerValue.enable_sso_login
                        ? _c("validation-provider", {
                            attrs: {
                              name: "selected_ssos",
                              rules: "required",
                              slim: true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("base-select", {
                                        attrs: {
                                          name: "selected_ssos",
                                          options: _vm.availableSSOs,
                                          "track-by": "value",
                                          "only-emit-value": true,
                                          "allow-empty": false,
                                          multiple: true,
                                          "hide-selected": true,
                                          label: _vm.t(
                                            "authentication_type.sso_select"
                                          ),
                                          errors: errors,
                                        },
                                        model: {
                                          value: _vm.selectedSSOs,
                                          callback: function ($$v) {
                                            _vm.selectedSSOs = $$v
                                          },
                                          expression: "selectedSSOs",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ]
                  },
                }
              : null,
            _vm.registrationType !== "private"
              ? {
                  key: "manual_approval",
                  fn: function (ref) {
                    return [
                      _c("p", [
                        _vm._v(_vm._s(_vm.t("manual_approval_description"))),
                        _c("br"),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.$utils.links.getLinkUrl(
                                "manual_user_approval"
                              ),
                              title: _vm.t("learn_more"),
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                          },
                          [_vm._v(_vm._s(_vm.t("learn_more")))]
                        ),
                      ]),
                      _c("toggler", {
                        attrs: {
                          value: _vm.innerValue.manual_approval,
                          name: "manual_approval",
                          disabled: _vm.disableManualApproval,
                          tip:
                            _vm.disableManualApproval && _vm.hasSessionsInForms
                              ? _vm.t("remove_sessions_reg_to_enable")
                              : null,
                          "on-label":
                            "registration.configuration.manual_approval_label",
                          "off-label":
                            "registration.configuration.manual_approval_label",
                        },
                        on: {
                          input: function (value) {
                            return _vm.setValue("manual_approval", value)
                          },
                        },
                      }),
                      _vm.innerValue.manual_approval
                        ? _c(
                            "div",
                            { staticClass: "hint-manage-pending" },
                            [
                              _c(
                                "i18n",
                                {
                                  attrs: {
                                    path: "registration.configuration.hint_manage_pending",
                                    tag: "p",
                                  },
                                },
                                [
                                  _vm._t("manual-approval-link", function () {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "/event/" +
                                              _vm.event._id +
                                              "/pax-requests",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.t("manage_pending_link_label")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                }
              : null,
            _vm.registrationType !== "private"
              ? {
                  key: "email_domains",
                  fn: function (ref) {
                    return [
                      _c("p", [
                        _vm._v(_vm._s(_vm.t("email_domains_description"))),
                      ]),
                      _c("base-select", {
                        attrs: {
                          name: "email_domains",
                          options: _vm.emailDomainsPolicyOptions,
                          "track-by": "value",
                          "only-emit-value": true,
                          "allow-empty": false,
                          label: _vm.t("form.email_domains.label"),
                        },
                        model: {
                          value: _vm.emailPolicy,
                          callback: function ($$v) {
                            _vm.emailPolicy = $$v
                          },
                          expression: "emailPolicy",
                        },
                      }),
                      _vm.innerValue.email_domains_policy === "pass_list"
                        ? _c(
                            "div",
                            { staticClass: "feature-dependant" },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "email_domains_pass",
                                  rules: "required",
                                  slim: true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("strings-array-input", {
                                            attrs: {
                                              label: _vm.t(
                                                "form.domains_listing"
                                              ),
                                              name: "email_domains_pass",
                                              value:
                                                _vm.innerValue
                                                  .email_domains_pass,
                                              errors: errors,
                                              placeholder: _vm.t(
                                                "form.email_domains_pass_placeholder"
                                              ),
                                              "tag-transform":
                                                _vm.normalizeDomain,
                                            },
                                            on: {
                                              input: function (value) {
                                                return _vm.setValue(
                                                  "email_domains_pass",
                                                  value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.innerValue.email_domains_policy === "block_list"
                        ? _c(
                            "div",
                            { staticClass: "feature-dependant" },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "block_list",
                                  rules: _vm.innerValue.email_domains_block_free
                                    ? ""
                                    : "required",
                                  slim: true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("strings-array-input", {
                                            attrs: {
                                              label: _vm.t(
                                                "form.domains_listing"
                                              ),
                                              name: "email_domains_block",
                                              errors: errors,
                                              value:
                                                _vm.innerValue
                                                  .email_domains_block,
                                              placeholder: _vm.t(
                                                "form.email_domains_block_placeholder"
                                              ),
                                              "tag-transform":
                                                _vm.normalizeDomain,
                                            },
                                            on: {
                                              input: function (value) {
                                                return _vm.setValue(
                                                  "email_domains_block",
                                                  value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("checkbox", {
                                attrs: {
                                  name: "email_domains_block_free",
                                  value:
                                    _vm.innerValue.email_domains_block_free,
                                  label: _vm.t("form.email_domains_block_free"),
                                },
                                on: {
                                  input: function (value) {
                                    return _vm.setValue(
                                      "email_domains_block_free",
                                      value
                                    )
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "hint",
                                      fn: function (ref) {
                                        return [
                                          _c(
                                            "i18n",
                                            {
                                              staticClass: "small",
                                              attrs: {
                                                path: "registration.configuration.free_domains_list",
                                                tag: "p",
                                              },
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: _vm.$utils.links.getLinkUrl(
                                                      "free_email_domains_list"
                                                    ),
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.t(
                                                        "free_domains_list_link_label"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                }
              : null,
            _vm.showNotificationsOptions
              ? {
                  key: "notification_emails",
                  fn: function (ref) {
                    return [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.t("form.capacity_reached_emails"))),
                      ]),
                      _c(
                        "i18n",
                        {
                          attrs: {
                            path: "registration.configuration.capacity_reached_emails_hint_1",
                            tag: "p",
                          },
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.t("capacity_reached_emails_hint_2"))
                            ),
                          ]),
                        ]
                      ),
                      _c("validation-provider", {
                        attrs: {
                          name: "capacity_reached_emails",
                          rules: "emails",
                          slim: true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("strings-array-input", {
                                    attrs: {
                                      name: "capacity_reached_emails",
                                      value:
                                        _vm.innerValue.capacity_reached_emails,
                                      errors: errors,
                                      placeholder: _vm.t(
                                        "form.notification_emails_placeholder"
                                      ),
                                      "tag-transform": _vm.normalizeDomain,
                                    },
                                    on: {
                                      input: function (value) {
                                        return _vm.setValue(
                                          "capacity_reached_emails",
                                          value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("horizontal-divider"),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.t("form.notifications_emails"))),
                      ]),
                      _c(
                        "i18n",
                        {
                          attrs: {
                            path: "registration.configuration.notifications_1",
                            tag: "p",
                          },
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.t("notifications_2"))),
                          ]),
                        ]
                      ),
                      _c("validation-provider", {
                        attrs: {
                          name: "notification_emails",
                          rules: "emails",
                          slim: true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("strings-array-input", {
                                    attrs: {
                                      name: "notification_emails",
                                      value: _vm.innerValue.notification_emails,
                                      errors: errors,
                                      placeholder: _vm.t(
                                        "form.notification_emails_placeholder"
                                      ),
                                      "tag-transform": _vm.normalizeDomain,
                                    },
                                    on: {
                                      input: function (value) {
                                        return _vm.setValue(
                                          "notification_emails",
                                          value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  },
                }
              : null,
            _vm.showPaymentSettings
              ? {
                  key: "payment",
                  fn: function (ref) {
                    return [
                      _c("p", [_vm._v(_vm._s(_vm.t("payment_description")))]),
                      _c("toggler", {
                        attrs: {
                          name: "payment",
                          "on-label":
                            "registration.configuration.payment_label",
                          "off-label":
                            "registration.configuration.payment_label",
                        },
                        on: {
                          input: function (value) {
                            return _vm.setValue("payment_enabled", value)
                          },
                        },
                        model: {
                          value: _vm.paymentEnabled,
                          callback: function ($$v) {
                            _vm.paymentEnabled = $$v
                          },
                          expression: "paymentEnabled",
                        },
                      }),
                      _vm.paymentEnabled
                        ? _c(
                            "div",
                            { staticClass: "feature-dependant" },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "payment_event_id",
                                  rules: "required",
                                  slim: true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("base-input", {
                                            attrs: {
                                              label: _vm.t(
                                                "form.vivenu_event_id"
                                              ),
                                              name: "payment_event_id",
                                              errors: errors,
                                            },
                                            on: {
                                              input: function (value) {
                                                return _vm.setValue(
                                                  "payment_event_id",
                                                  value
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.paymentEventId,
                                              callback: function ($$v) {
                                                _vm.paymentEventId = $$v
                                              },
                                              expression: "paymentEventId",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                }
              : null,
            {
              key: "embed",
              fn: function (ref) {
                return [
                  _c("toggler", {
                    attrs: {
                      name: "enable_embed",
                      "on-label":
                        "registration.configuration.actions.enable_embed",
                      "off-label":
                        "registration.configuration.actions.enable_embed",
                    },
                    model: {
                      value: _vm.enableEmbed,
                      callback: function ($$v) {
                        _vm.enableEmbed = $$v
                      },
                      expression: "enableEmbed",
                    },
                  }),
                  _vm.enableEmbed
                    ? [
                        _c("div", { staticClass: "alert alert-notice" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("registration.configuration.embed_alert")
                            )
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("registration.configuration.embed_info")
                            )
                          ),
                        ]),
                        _c("label", { staticClass: "snippet-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("registration.configuration.embed_label")
                            )
                          ),
                        ]),
                        _c("p", { staticClass: "label-description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("registration.configuration.embed_choice")
                            )
                          ),
                        ]),
                        _c("buttons-toggle", {
                          attrs: { choices: _vm.embedCodeButtonList },
                          on: {
                            toggle: function (value) {
                              return (_vm.embedCodeVersion = value)
                            },
                          },
                        }),
                        _c("p", { staticClass: "control-hint embedding" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "registration.configuration.embed_utm_info"
                                )
                              )
                            ),
                          ]),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.$utils.links.getLinkUrl(
                                  "registration_page_utm_tracking"
                                ),
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "registration.configuration.embed_utm_link"
                                  )
                                )
                              ),
                            ]
                          ),
                        ]),
                        _vm.embedCodeVersion === "basic"
                          ? [
                              _c("pre", { staticClass: "embed-code" }, [
                                _vm._v(_vm._s(_vm.getEmbedCode())),
                              ]),
                              _c(
                                "button",
                                {
                                  staticClass: "btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.copyEmbedCodeToClipboard(
                                        _vm.getEmbedCode()
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "registration.configuration.embed_code_copy"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm.embedCodeVersion === "with_utm"
                          ? [
                              _c("pre", { staticClass: "embed-code" }, [
                                _vm._v(_vm._s(_vm.getEmbedCodeWithUtm())),
                              ]),
                              _c(
                                "button",
                                {
                                  staticClass: "btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.copyEmbedCodeToClipboard(
                                        _vm.getEmbedCodeWithUtm()
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "registration.configuration.embed_code_copy"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ]
              },
            },
            {
              key: "access_code",
              fn: function (ref) {
                return [
                  _c(
                    "div",
                    { staticClass: "access_code" },
                    [
                      _c("toggler", {
                        attrs: {
                          name: "skip_pin_for_team_members",
                          "on-label":
                            "registration.configuration.actions.skip_pin",
                          "off-label":
                            "registration.configuration.actions.skip_pin",
                          hint: _vm.t("actions.skip_pin_hint"),
                        },
                        model: {
                          value: _vm.skipPinCode,
                          callback: function ($$v) {
                            _vm.skipPinCode = $$v
                          },
                          expression: "skipPinCode",
                        },
                      }),
                      _c("div", { staticClass: "help" }, [
                        _c("span", [_vm._v(_vm._s(_vm.t("need_help")))]),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.$utils.links.getLinkUrl(
                                "manual_user_approval"
                              ),
                              title: _vm.t("learn_more"),
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                          },
                          [_vm._v(_vm._s(_vm.t("learn_more")))]
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "social_media_integration",
              fn: function (ref) {
                return [
                  _c("validation-provider", {
                    attrs: { name: "gtm_container_id", slim: true },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var errors = ref.errors
                            return [
                              _c("base-input", {
                                attrs: {
                                  label: _vm.t("gtm_container_id"),
                                  name: "gtm_container_id",
                                  errors: errors,
                                  hint: _vm.t("gtm_container_id_hint"),
                                  "hint-after-label": true,
                                  placeholder: "GTM-XXXXXXX",
                                },
                                model: {
                                  value: _vm.gtmContainerId,
                                  callback: function ($$v) {
                                    _vm.gtmContainerId = $$v
                                  },
                                  expression: "gtmContainerId",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  false
                    ? _c("validation-provider", {
                        attrs: { name: "linkedin_partner_id", slim: true },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("base-input", {
                                    attrs: {
                                      label: _vm.t("linkedin_partner_id"),
                                      name: "linkedin_partner_id",
                                      errors: errors,
                                      hint: _vm.t("linkedin_partner_id_hint"),
                                      "hint-after-label": true,
                                    },
                                    model: {
                                      value: _vm.linkedinPartnerId,
                                      callback: function ($$v) {
                                        _vm.linkedinPartnerId = $$v
                                      },
                                      expression: "linkedinPartnerId",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "modal",
        {
          attrs: {
            name: "disable-registration",
            "click-to-close": false,
            classes: "small",
            height: "auto",
          },
        },
        [
          _c("div", { staticClass: "modal-header" }, [
            _c("a", {
              staticClass: "close",
              on: {
                click: function ($event) {
                  return _vm.toggleRegistration(false)
                },
              },
            }),
            _c("h2", [_vm._v(_vm._s(_vm.t("disable_modal.title")))]),
          ]),
          _c("div", { staticClass: "modal-body" }, [
            _c("strong", [_vm._v(_vm._s(_vm.t("disable_modal.text_1")))]),
            _c("br"),
            _c("br"),
            _vm._v(_vm._s(_vm.t("disable_modal.text_2"))),
          ]),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.toggleRegistration(false)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("general.cancel")))]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.toggleRegistration(true)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.t("disable_modal.action")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/registrations/Settings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__